import { render, staticRenderFns } from "./JobOffer.vue?vue&type=template&id=8207a922"
import script from "./JobOffer.vue?vue&type=script&lang=js"
export * from "./JobOffer.vue?vue&type=script&lang=js"
import style0 from "./JobOffer.vue?vue&type=style&index=0&id=8207a922&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports